import {
  CouponsResponseDto,
  ResultPaginationResponseDto,
} from '@tiendanube/common';
import axios from 'App/axios';

export const searchCouponsByQuery = async (
  query: string,
): Promise<CouponsResponseDto[]> => {
  if (!query) return [];

  const response = await axios.get<
    ResultPaginationResponseDto<CouponsResponseDto[]>
  >('v1/coupons', {
    params: {
      q: query,
      page: '1',
    },
  });

  return response.data.results;
};

export const getCoupon = async (id: string): Promise<CouponsResponseDto> => {
  const response = await axios.get(`v1/coupons/${id}`);
  return response.data;
};
